import {
  setIntegrationId,
  setPartnerUnauthBooking,
  setReturnPath,
} from './../actions/booking.actions';
import { Action, createReducer, on } from '@ngrx/store';
import { AppointmentBookingMode } from 'app/shared/appointments/models/appointment-booking-mode.enum';

import {
  setBookingReasonId,
  setCaseId,
  setPartnerToken,
  setPractitionerId,
  setServiceId,
  setStartDateTime,
  setSysAppointmentDeliveryMethodId,
  setTreatmentPlanId,
  setIsForWaitingListFlag,
} from '../actions';

export interface BookingState {
  practitionerId?: number;
  serviceId?: number;
  startDateTime?: string;
  caseId?: number;
  appointmentBookingMode?: AppointmentBookingMode;
  bookingReasonId?: number;
  treatmentPlanId?: number;
  partnerToken?: string;
  partnerUnauthBooking?: boolean;
  isBooking: boolean;
  sysAppointmentDeliveryMethodId?: number;
  isForWaitingList?: boolean;
  integrationId?: number;
  returnPath?: string;
}

const initialState: BookingState = {
  practitionerId: undefined,
  serviceId: undefined,
  startDateTime: undefined,
  caseId: undefined,
  appointmentBookingMode: undefined,
  bookingReasonId: undefined,
  treatmentPlanId: undefined,
  partnerToken: undefined,
  partnerUnauthBooking: undefined,
  isBooking: false,
  sysAppointmentDeliveryMethodId: undefined,
  isForWaitingList: undefined,
  integrationId: undefined,
  returnPath: undefined,
};

const bReducer = createReducer(
  initialState,
  on(setPractitionerId, (state, { practitionerId }) => ({
    ...state,
    practitionerId: practitionerId,
  })),
  on(setServiceId, (state, { serviceId }) => ({
    ...state,
    serviceId: serviceId,
  })),
  on(setStartDateTime, (state, { startDateTime }) => ({
    ...state,
    startDateTime: startDateTime,
  })),
  on(setCaseId, (state, { caseId }) => ({
    ...state,
    caseId: caseId,
  })),
  on(setBookingReasonId, (state, { bookingReasonId }) => ({
    ...state,
    bookingReasonId: bookingReasonId,
  })),
  on(setTreatmentPlanId, (state, { treatmentPlanId }) => ({
    ...state,
    treatmentPlanId: treatmentPlanId,
  })),
  on(setIntegrationId, (state, { integrationId: integrationId }) => ({
    ...state,
    integrationId: integrationId,
  })),
  on(setPartnerToken, (state, { partnerToken }) => ({
    ...state,
    partnerToken: partnerToken,
  })),
  on(setPartnerUnauthBooking, (state, { partnerUnauthBooking }) => ({
    ...state,
    partnerUnauthBooking: partnerUnauthBooking,
  })),
  on(setSysAppointmentDeliveryMethodId, (state, { sysAppointmentDeliveryMethodId }) => ({
    ...state,
    sysAppointmentDeliveryMethodId: sysAppointmentDeliveryMethodId,
  })),
  on(setIsForWaitingListFlag, (state, { isForWaitingList: isForWaitingList }) => ({
    ...state,
    isForWaitingList,
  })),
  on(setReturnPath, (state, { returnPath: returnPath }) => ({
    ...state,
    returnPath,
  }))
);

export function bookingReducer(state: BookingState | undefined, action: Action): BookingState {
  return bReducer(state, action);
}

export const getBookingState = (state: BookingState): BookingState | undefined =>
  state ? state : undefined;
